module.exports = __webpack_public_path__ + "img/dodLogOutIcon.6e2682b9.svg";